import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import sha1 from 'sha1';
import React, { Component } from 'react'; // https://haveibeenpwned.com/API/v2#SearchingPwnedPasswordsByRange

var HASH_PREFIX_LENGTH = 5;

var HIBPPasswordChecker =
/*#__PURE__*/
function (_Component) {
  _inherits(HIBPPasswordChecker, _Component);

  function HIBPPasswordChecker(props) {
    var _this;

    _classCallCheck(this, HIBPPasswordChecker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HIBPPasswordChecker).call(this, props));
    _this.state = {
      initial: true,
      loading: false,
      pwned: false,
      count: 0
    };
    return _this;
  }

  _createClass(HIBPPasswordChecker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!nextProps.password) {
        this.setState({
          initial: true
        });
      } else if (nextProps.password !== this.props.password) {
        if (this.interval) {
          clearTimeout(this.interval);
        }

        this.interval = setTimeout(function () {
          _this2.checkPassword(nextProps.password);
        }, 200);
      }
    }
  }, {
    key: "checkPassword",
    value: function checkPassword(password) {
      var _this3 = this;

      var hash = sha1(password).toUpperCase();
      var prefix = hash.substr(0, HASH_PREFIX_LENGTH);
      var suffix = hash.substr(HASH_PREFIX_LENGTH);
      this.setState({
        initial: false,
        loading: true,
        pwned: false,
        error: null
      });
      fetch("https://api.pwnedpasswords.com/range/".concat(prefix), {
        headers: {
          Accept: "application/vnd.haveibeenpwned.v2+json"
        }
      }).then(function (resp) {
        return resp.ok ? resp.text() : Promise.reject(resp.text());
      }).then(function (resp) {
        return resp.split('\n').map(function (entry) {
          var _entry$split = entry.split(":"),
              _entry$split2 = _slicedToArray(_entry$split, 2),
              suffix = _entry$split2[0],
              count = _entry$split2[1];

          return {
            suffix: suffix,
            count: parseInt(count, 10)
          };
        });
      }).then(function (results) {
        var result = results.find(function (result) {
          return result.suffix === suffix;
        });

        _this3.setState({
          pwned: !!result,
          count: result ? result.count : 0,
          loading: false,
          error: null
        });
      }).catch(function (e) {
        _this3.setState({
          loading: false,
          error: e
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          initial = _this$state.initial,
          loading = _this$state.loading,
          error = _this$state.error,
          pwned = _this$state.pwned,
          count = _this$state.count;
      return this.props.children({
        initial: initial,
        loading: loading,
        error: error,
        pwned: pwned,
        count: count
      });
    }
  }]);

  return HIBPPasswordChecker;
}(Component);

export { HIBPPasswordChecker as default };